import axios from "axios";
import { API_END_POINT } from "../../constants/api";

import { returnErrors, clearErrors } from "./errorAction";

export const ADD_DISPATCH = "ADD_DISPATCH";
export const ADD_DISPATCH_SUCCESFULL = "ADD_DISPATCH_SUCCESFULL";
export const ADD_DISPATCH_FAIL = "ADD_DISPATCH_FAIL";
export const GET_DISPATCHES = "GET_DISPATCHES";
export const DISPATCH_HISTORY = "DISPATCH_HISTORY";
export const COMPANY_DISPATCHES_HIS = "COMPANY_DISPATCHES_HIS";

export const DISPATCH_EDIT = "DISPATCH_EDIT";
export const DISPATCH_EDIT_FAIL = "DISPATCH_EDIT_FAIL";
export const DISPATCH_EDIT_SUCCESFULL = "DISPATCH_EDIT_SUCCESFULL";

export const CLOTH_RETURN_EDIT = "CLOTH_RETURN_EDIT";
export const CLOTH_RETURN_SUCCESFULL = "CLOTH_RETURN_SUCCESFULL";
export const CLOTH_RETURN_FAIL = "CLOTH_RETURN_FAIL";

export function addDispatch(dispatches) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const values = {
      ...dispatches,
      date_dispatch: dispatches.date_dispatch.format("YYYY-MM-DD"),
    };

    axios
      .post(`${API_END_POINT}/api/Contract/Dispatch/Register`, values, config)
      .then((res) =>
        dispatch({
          type: ADD_DISPATCH,
          payload: res.data,
        })
      )
      .then((data) =>
        dispatch(
          clearErrors(
            "Dispatch add Successfully",
            201,
            "ADD_DISPATCH_SUCCESFULL"
          )
        )
      )
      .then(() => dispatch(clearErrors()))
      .catch((err) =>
        dispatch(
          returnErrors(
            err.response.data,
            err.response.status,
            "ADD_DISPATCH_FAIL"
          )
        )
      )
      .then(() => dispatch(clearErrors()));
  };
}
//this api get the dispatch only not return
export function getDispatch(params) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const body = JSON.stringify(params);

    axios
      .post(`${API_END_POINT}/api/Contract/Dispatch/Get`, body, config)
      .then((res) =>
        dispatch({
          type: GET_DISPATCHES,
          payload: res.data,
        })
      )
      .catch((err) => {
        console.log(err);
      });
  };
}

export function editDispatch(dispatchEdit, dispatch_Id) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const body = JSON.stringify(dispatchEdit);
    axios
      .put(
        `${API_END_POINT}/api/contract/dispatch/update/${dispatch_Id}`,
        body,
        config
      )
      .then((res) =>
        dispatch({
          type: DISPATCH_EDIT,
          payload: res.data[0],
        })
      )
      .then((data) =>
        dispatch(
          clearErrors(
            "Dispatch edit Successfully",
            201,
            "DISPATCH_EDIT_SUCCESFULL"
          )
        )
      )
      .then(() => dispatch(clearErrors()))
      .catch((err) =>
        dispatch(
          returnErrors(
            err.response.data,
            err.response.status,
            "DISPATCH_EDIT_FAIL"
          )
        )
      )
      .then(() => dispatch(clearErrors()));
  };
}

//this api get the dispatches with cloth return history of contarct specific
export function contractDispatches(params) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const body = JSON.stringify(params);

    axios
      .post(
        `${API_END_POINT}/api/Contract/Inner/DispatchHistory/List`,
        body,
        config
      )
      .then((res) =>
        dispatch({
          type: DISPATCH_HISTORY,
          payload: res.data,
        })
      )
      .catch((err) => {
        console.log(err);
      });
  };
}

export function companyDispatches(params) {
  return (dispatch) => {
    const token = localStorage.getItem("usertoken");
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const body = JSON.stringify(params);

    axios
      .post(`${API_END_POINT}/api/company/dispatch-history/list`, body, config)
      .then((res) =>
        dispatch({
          type: COMPANY_DISPATCHES_HIS,
          payload: res.data,
        })
      )

      .catch((err) => {
        console.log(err);
      });
  };
}

export function editClothReturn(dispatchEdit, cloth_return_id) {
  console.log("dispatchEdit", dispatchEdit);
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const body = JSON.stringify(dispatchEdit);
    axios
      .put(
        `${API_END_POINT}/api/contract/cloth-return/update/${cloth_return_id}`,
        body,
        config
      )
      .then((res) =>
        dispatch({
          type: CLOTH_RETURN_EDIT,
          payload: res.data[0],
        })
      )
      .then((data) =>
        dispatch(
          clearErrors(
            "cloth Return edit Successfully",
            201,
            "CLOTH_RETURN_SUCCESFULL"
          )
        )
      )
      .then(() => dispatch(clearErrors()))
      .catch((err) =>
        dispatch(
          returnErrors(
            err.response.data,
            err.response.status,
            "CLOTH_RETURN_FAIL"
          )
        )
      )
      .then(() => dispatch(clearErrors()));
  };
}
